// extracted by mini-css-extract-plugin
export default {"Sidepanel":"Sidepanel1FQZEbqK0zhW","Sidepanel-status":"Sidepanel-status3Ov2N5y5Y6A4"};